<app-modal-header [close]="onCancelClick" title="Possible Errors"></app-modal-header>
<div>
  <div class="table-div">
    <ag-grid-angular
      (cellValueChanged)="onCellValueChanged()"
      (gridReady)="onGridReady($event)"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      [theme]="'legacy'"
      class="ag-theme-custom">
    </ag-grid-angular>
    <app-shared-modal-footer>
      <app-shared-button
        (click)="onCancelClick()"
        class="ignore-button"
        type="button">
        Cancel
      </app-shared-button>
      <app-shared-button
        (click)="onChangeButtonClick()"
        class="submit-button"
        type="button">
        Submit
      </app-shared-button>
    </app-shared-modal-footer>
  </div>
</div>
